import { Component, Vue, Prop, Provide } from 'vue-property-decorator'

import './Demo.scss';
import { SearchWidget } from '../SearchWidget';
import { EventBus, TEMED_WIDGET_EVENTS, SEARCH_WIDGET_EVENTS } from '../../services/EventBus';
import { AppService } from '../../services/AppService'
import { RandomItemsWidget } from '../RandomItemsWidget';
import { MostRatedWidget } from '../MostRatedWidget';
import { MostRatedSliderWidget } from '../MostRatedSliderWidget';

@Component({
  template: require('./Demo.html'),
  components: {
    'SearchWidget': SearchWidget,
    'RandomItemsWidget': RandomItemsWidget,
    'MostRatedWidget': MostRatedWidget,
    'MostRatedSliderWidget': MostRatedSliderWidget
  }
})
export class Demo extends Vue {

  @Prop({default: 'demo prop value'})
  demoProp: string;

  searchWidgetExpanded = true;

  appService: AppService;

  created(){
    this.appService = AppService.getInstance();
  }

  test () {
    console.log('[%s]: test called', this.$options.name)
    console.log('[%s.demoProp]:', this.$options.name, this.demoProp);
  }

  mounted () {
    this.test()
    EventBus.$on(TEMED_WIDGET_EVENTS.TEST_EVENT, () => {
      console.log('[%s]: [%s]', this.$options.name, TEMED_WIDGET_EVENTS.TEST_EVENT)
    });
  }


  toggleSearchWidget(){
    this.searchWidgetExpanded = !this.searchWidgetExpanded;

    EventBus.$emit(SEARCH_WIDGET_EVENTS.SEARCH_TOGGLE_FORM, this.searchWidgetExpanded);
  }
}
